import deletePatient from "@custom/rtk-apis/patients/deletePatient";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const deletePatientSlice = createSlice({
  name: "deletePatientSlice",
  initialState,
  reducers: {
    closePatientDeleteModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(deletePatient.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(deletePatient.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deletePatient.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deletePatientSlice.reducer;
export const { closePatientDeleteModal } = deletePatientSlice.actions;
